document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[data-jy-collections-index]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const index = document.getElementById(link.hash.slice(1));
  if (!index || index.tagName !== 'DETAILS') return;

  event.preventDefault();
  index.open = true;
  index.scrollIntoView({ block: 'start' });
  index.querySelector('summary')?.focus({ preventScroll: true });
  if (location.hash !== link.hash) history.pushState(null, '', link.hash);
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[data-jy-taxonomy-anchor]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ block: 'start' });
  target.focus({ preventScroll: true });
  if (location.hash !== link.hash) history.pushState(null, '', link.hash);
});
